import { Container, Spinner } from "react-bootstrap";
import MediaQueryTool from "../../utils/MediaQueryTool";
import { ImageGallery } from "react-image-grid-gallery";
import { useEffect, useState } from "react";
import axios from "axios";

const Gallery = () => {
  const mediaQueryTool = MediaQueryTool();
  const [selected, setSelected] = useState("All");
  const [original, setOriginal] = useState(null);
  const [list, setList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const buttonList = [
    "All",
    "Character",
    "Sketch",
    "Illustration",
    "Games",
    "Anime",
  ];

  useEffect(() => {
    setIsLoading(true);

    axios
      .get("https://sugarno_backend.sugarnoproject.workers.dev/getImage")
      .then((response) => {
        setOriginal(response.data.data);

        const array = response.data.data.map((item) => ({
          id: item.id,
          alt: "Sugarno " + item.name,
          caption: item.name,
          src: item.url,
        }));

        setList(array);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    setList(null);

    if (original) {
      if (selected === "All") {
        const array = original.map((item) => ({
          id: item.id,
          alt: item.name,
          caption: item.name,
          src: item.url,
        }));

        setList(array);
      } else {
        const array = original
          .filter((item) => item.category === selected)
          .map((item) => ({
            id: item.id,
            alt: item.name,
            caption: item.name,
            src: item.url,
          }));

        setTimeout(() => {
          setList(array.length > 0 ? array : null);
        }, 0);
      }
    }
  }, [selected, original]);

  return (
    <>
      <Container
        className="d-flex flex-column align-items-center"
        style={{
          marginTop: 90,
          color: "white",
          paddingLeft: mediaQueryTool.isXL ? 200 : undefined,
          paddingRight: mediaQueryTool.isXL ? 200 : undefined,
        }}
      >
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional overlay
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <h1
          className="neon-text2"
          style={{
            fontFamily: "CyberpunkFont",
          }}
        >
          Gallery
        </h1>
        <p className="text-center">
          Welcome to the gallery! Explore a curated collection of artworks,
          showcasing creativity, technique, and artistic expression.
        </p>
      </Container>
      <Container
        className="mt-4 d-flex gap-3"
        style={{
          overflowX: "auto",
          justifyContent: mediaQueryTool.isXS ? undefined : "center",
        }}
      >
        {buttonList.map((item, index) => (
          <button
            key={index}
            className="px-4 py-2 "
            style={{
              color: "white",
              cursor: "pointer",
              fontSize: 18,
              borderRadius: 5,
              backgroundColor: "transparent",
              border: selected === item ? "2px solid cyan" : undefined,
            }}
            onClick={() => setSelected(item)}
          >
            {item}
          </button>
        ))}
      </Container>
      <Container className="d-flex mt-5 flex-wrap">
        {list && (
          <ImageGallery
            imagesInfoArray={list}
            columnCount={"auto"}
            columnWidth={!mediaQueryTool.isXS ? 300 : 140}
            gapSize={23}
          />
        )}
      </Container>
    </>
  );
};

export default Gallery;
